module.exports = __webpack_public_path__ + "images/3c2e42cbf9d0b0df0d3b3bb81aa41d6a.svg";